











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.ValidateLostPasswordTokenCommand')
    
    export class ValidateLostPasswordTokenCommand {
        constructor( token: string ) {
            
                this.token = token;
            
        }

        
            public token: string;
        
    }

    export interface IValidateLostPasswordTokenCommand {
        
            token: string;
        
    }

    export async function validateLostPasswordToken( command: ValidateLostPasswordTokenCommand ): Promise<CommandResult<void>>
    export async function validateLostPasswordToken( { token }: IValidateLostPasswordTokenCommand ): Promise<CommandResult<void>>
    export async function validateLostPasswordToken( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof ValidateLostPasswordTokenCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new ValidateLostPasswordTokenCommand( model['token'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace ValidateLostPasswordTokenCommand.ExtraneousTypes {
        

        
    }

